// extracted by mini-css-extract-plugin
export var actions = "_8u-8";
export var arrow = "_8u-5";
export var card = "_8u-0";
export var cardWrapper = "_8u-9";
export var fieldName = "_8u-3";
export var newValue = "_8u-6";
export var oldValue = "_8u-4";
export var orangeGlowFade = "_8u-c";
export var productSection = "_8u-1";
export var scrollToBottom = "_8u-b";
export var scrollToBottomAnchor = "_8u-a";
export var scrollToBottomIcon = "_8u-d";
export var showAllButton = "_8u-7";
export var table = "_8u-2";